// Centralized runtime flags so we do not scatter env checks across the app.
const coerceBoolean = (value: unknown): boolean => {
  if (value == null) return false
  const normalized = String(value).trim().toLowerCase()
  return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on'
}

export const isDevBuild = import.meta.env.DEV

export const enableStoreDevtools = isDevBuild || coerceBoolean(import.meta.env.VITE_ENABLE_STORE_DEVTOOLS)

export const showConnectionDebug = isDevBuild || coerceBoolean(import.meta.env.VITE_ENABLE_CONNECTION_DEBUG)
